import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button as ANTButton, Form, Space, notification, Checkbox } from 'antd';
import { Button } from '../../components/Atom/Button';
import Select from 'components/Atom/Select';
import { useLocation } from 'react-router-dom';
import Input from 'components/Atom/Input';
import { useQuery, useQueryClient } from 'react-query';
import http from '../../utils/http';
import { getUsersRole } from 'utils/services';
import { CautionIcon } from 'assets/icons';
import SelectStore from 'components/SelectStore';
import DateTimePicker from 'components/Atom/DateTimePicker';
import moment from 'moment';
import { STORE_API_VERSION } from 'utils/constant';
import { SUB_CurrencyNames } from 'utils/services';
const GeneratePaymentLink = ({ handleOpen, updateState }) => {
  const [store, setStore] = useState(useSelector((state) => state.company.store));
  const userStores = useSelector((state) => state.company.userStores);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [currency, setCurrency] = useState(null);
  const [merchantData, setMerchantData] = useState(null);
  const [inventoryPolicy, setInventoryPolicy] = useState('decrement_obeying_policy');
  const [instanceId, setInstanceId] = useState(null);
  const queryClient = useQueryClient();
  const [paymentLinkType, setPaymentLinkType] = useState('one_time_use');
  const { isPlatformAccount } = getUsersRole();
  const onStoreChange = (e) => {
    setStore(e);
    setInstanceId(null);
    setMerchantData(null);
    if (paymentLinkType !== 'one_time_use') {
      setPaymentLinkType('one_time_use');
    }
  };
  const getEnabledLinkedAccountData = async () => {
    const res = await http.get(`/linked/account/verified/data/${store?._id}`);
    const filteredData = res?.data?.data?.linkedAccounts.map((data) => ({
      label: `${data?.userAccountId} - ${data?.userStoreId?.name ? data?.userStoreId?.name : data?.userStoreId?.domain}`,
      value: `${data?.userAccountId}-${data?.userStoreId?._id}`,
    }));
    return { filteredLinkAccountData: filteredData, ...res?.data?.data };
  };
  const getInstanceData = async () => {
    const store_id = location?.state?.order_id ? location?.state?.store_id : store?._id;
    const res = await http.get(`/config/gateway/${store_id}`);
    const mappedInstance = res?.data?.data?.map((data) => ({
      label: data?.name,
      value: data?._id,
    }));
    return mappedInstance;
  };
  const {
    data: instanceData,
    refetch: fetchInstanceData,
    isLoading: isInstanceFetching,
  } = useQuery('gatewayInstanceQuery', getInstanceData, {
    enabled: false,
    manual: true,
  });
  const { data: linkedAccountsData, refetch: fetchLinkedAccounts } = useQuery('linkedAccountData', getEnabledLinkedAccountData, {
    enabled: false,
    manual: true,
  });
  useEffect(() => {
    setCurrency(store?.currency?.code);
    if (isPlatformAccount && store?.apiVersion === STORE_API_VERSION.OCTOBER_23 && !location?.state?.order_id) {
      fetchLinkedAccounts();
    }
    if (store?.apiVersion === STORE_API_VERSION.OCTOBER_23) {
      fetchInstanceData();
    } else if (instanceData) {
      queryClient.setQueryData('gatewayInstanceQuery', null);
    }
  }, [store]);

  const LinkTypeData = [
    {
      label: 'One Time Use',
      value: 'one_time_use',
    },
    {
      label: 'Multiple Use',
      value: 'multiple_use',
    },
  ];
  const InventoryData = [
    {
      label: 'DECREASE',
      value: 'decrement_obeying_policy',
    },
    {
      label: 'DO NOT CHANGE',
      value: 'bypass',
    },
  ];
  /* const CurrencyData = [
    {
      label: 'PKR',
      value: 'PKR',
    },
    {
      label: 'USD',
      value: 'USD',
    },
  ]; */
  const values = {
    reOrderId: location?.state?.order_id ?? '',
  };
  const findSelectedAccountGatewayInstance = (store_id) => {
    const filteredData = linkedAccountsData?.linkedAccounts?.find((data) => data?.userStoreId?._id === store_id);
    const filteredInstance = filteredData?.assignedGatewayInstance?.map((data) => ({
      label: data?.instanceName,
      value: data?.instanceId,
    }));
    queryClient.setQueryData('gatewayInstanceQuery', filteredInstance);
  };
  const handleMerchantSourceChange = (e) => {
    const linkedAccountData = e?.value?.split('-');
    if (linkedAccountData) {
      setMerchantData({ merchant_id: linkedAccountData[0] ?? null, store_id: linkedAccountData[1] ?? null });
      findSelectedAccountGatewayInstance(linkedAccountData[1]);
    } else {
      setMerchantData(null);
    }
    setInstanceId(null);
  };
  const onInstanceSelect = (e) => {
    setInstanceId(e?.value || null);
  };
  const handleInventoryChange = (e) => {
    setInventoryPolicy(e.value);
  };
  const handelAmount = (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g);
  };
  const handleCurrencyChange = (e) => {
    setCurrency(e.value);
  };
  const handleOnClear = () => {
    if (store?.apiVersion === STORE_API_VERSION.OCTOBER_23) {
      fetchInstanceData();
    } else if (instanceData) {
      queryClient.setQueryData('gatewayInstanceQuery', null);
    }
  };
  const onSubmit = async (data) => {
    setLoading(true);
    let payload;
    const store_id = location?.state?.order_id ? location?.state?.store_id : store?._id;
    const endPointUri = location?.state?.order_id ? 'shopify' : 'custom';
    if (location?.state?.order_id) {
      const { reOrderId } = data;
      payload = {
        order_id: reOrderId,
        ...(instanceId && { gateway_instance_id: instanceId }),
        inventory_behaviour: inventoryPolicy,
      };
    } else {
      const { reOrderId, amount, linkUsageLimit, paymentLinkExpiry, name, emailId, session_timer } = data;
      const setExpiry = paymentLinkExpiry ? moment(paymentLinkExpiry).format('YYYY-MM-DD HH:mm:ss') : undefined;
      payload = {
        ...(instanceId && { gateway_instance_id: instanceId }),
        isTimedSession: session_timer,
        order: {
          id: reOrderId,
          currency: currency || 'PKR',
          order_amount: Number(amount),
        },
        multipleUse: paymentLinkType !== 'one_time_use',
        linkUsageLimit: linkUsageLimit || null,
        ...(merchantData?.merchant_id && { linkedAccount: merchantData }),
        setExpiry,
        ...(!store?.apiVersion && {
          customer: {
            name: name,
            email: emailId,
          },
        }),
      };
    }
    try {
      const response = await http.post(`/public/v1/payment/link/xap/${endPointUri}/${store_id}`, payload);
      updateState(response?.data?.data?.payment_link);
      handleOpen();
    } catch (err) {
      notification.error({ message: err?.response?.data?.message || 'SOMETHING WENT WRONG', placement: 'bottomRight' });
    }
    setLoading(false);
  };
  return (
    <div className='paymentLink'>
      <Form layout='vertical' method='post' initialValues={values} onFinish={onSubmit}>
        <div className='generate-payment-link'>
          {userStores?.length > 1 && !location?.state?.order_id && (
            <Form.Item className='formFields customFont customSelectLink' label='Store'>
              <SelectStore isLocalUse={true} setDefault={true} onChange={onStoreChange} />
            </Form.Item>
          )}
          {store?.apiVersion === STORE_API_VERSION.OCTOBER_23 && !location?.state?.order_id && (
            <Form.Item label='Link Usage' className='formFields customFont customSelectLink'>
              <Select handleChange={(e) => setPaymentLinkType(e.value)} optionsValue={LinkTypeData} />
            </Form.Item>
          )}
          {paymentLinkType === 'one_time_use' && (
            <Form.Item
              name='reOrderId'
              label='Order ID'
              className='formFields customFont steric-after'
              rules={[
                {
                  required: true,
                  message: 'Order ID is required',
                },
                {
                  message: "Invalid order ID. Only allow '- _' in the middle, and they cannot be used consecutively.",
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();
                    if (/^(?![_-]+$)(?!^[_-]+)(?!.*[_-]$)(?!.*--)(?!.*__)[a-zA-Z0-9_-]+$/.test(value)) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject('Invalid Order Id');
                    }
                  },
                },
              ]}>
              <Input className='rounded-lg' placeholder='Enter Order ID' name='reOrderId' disabled={!!location?.state?.order_id} style={{ height: '36px' }} />
            </Form.Item>
          )}
          {location?.state?.order_id ? (
            <Form.Item label='Inventory Policy' className='formFields customFont customSelectLink'>
              <Select handleChange={handleInventoryChange} optionsValue={InventoryData} />
            </Form.Item>
          ) : (
            <>
              {paymentLinkType !== 'one_time_use' && (
                <>
                  <Form.Item
                    name='linkUsageLimit'
                    label='Number of Usage'
                    className='formFields customFont steric-after'
                    rules={[
                      {
                        required: true,
                        message: 'Link usage limit is required',
                      },
                      {
                        message: 'Invalid link usage limit',
                        validator: (_, value) => {
                          if (!value) return Promise.resolve();
                          if (Number(value || 0) > 1) {
                            return Promise.resolve();
                          } else {
                            return Promise.reject('Invalid value');
                          }
                        },
                      },
                    ]}>
                    <Input placeholder='Enter Link Usage Limit' name='linkUsageLimit' onKeyUp={handelAmount} type={'number'} min='2' style={{ height: '36px' }} />
                  </Form.Item>
                  <div className='conquer filterFields gatewayRange'>
                    <Form.Item className='formFields formFieldsOne customFont' name='paymentLinkExpiry' label='Set Link Expiry'>
                      <DateTimePicker minMinutesFromNow={6} />
                    </Form.Item>
                  </div>
                </>
              )}

              {!store?.apiVersion && (
                <>
                  <Form.Item
                    name='name'
                    label='Customer Name'
                    className='formFields customFont steric-after'
                    rules={[
                      {
                        required: true,
                        message: 'Name is required',
                      },
                    ]}>
                    <Input placeholder='Enter Customer Name' name='name' style={{ height: '36px' }} />
                  </Form.Item>
                  <Form.Item
                    name='emailId'
                    label='Email'
                    className='formFields customFont steric-after'
                    rules={[
                      {
                        required: true,
                        message: 'Email is required',
                      },
                    ]}>
                    <Input placeholder='Enter Email' name='emailId' style={{ height: '36px' }} />
                  </Form.Item>
                </>
              )}
              <Form.Item
                name='amount'
                label='Order Amount'
                className='formFields customFont steric-after'
                rules={[
                  {
                    required: true,
                    message: 'Order Amount is required',
                  },
                  {
                    message: 'Invalid Order Amount',
                    validator: (_, value) => {
                      if (!value) return Promise.resolve();
                      if (Number(value || 0) > 0) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject('Invalid value');
                      }
                    },
                  },
                ]}>
                <Input placeholder='Enter Order Amount' name='amount' type='number' onKeyUp={handelAmount} style={{ height: '36px' }} min='1' />
              </Form.Item>
              <Form.Item label='Currency Code' className='formFields customFont customSelectLink'>
                <Select handleChange={handleCurrencyChange} defaultValue='PKR' optionsValue={SUB_CurrencyNames} />
              </Form.Item>
              {isPlatformAccount && linkedAccountsData?.filteredLinkAccountData?.length > 0 && (
                <>
                  <Form.Item label='Linked Account' className='formFields customFont customSelectLink'>
                    <Select
                      handleChange={handleMerchantSourceChange}
                      placeholder={'Select merchant account'}
                      showSearch
                      allowClear
                      onClear={handleOnClear}
                      getPopupContainer={(triggerNode) => triggerNode.parentElement}
                      filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                      optionsValue={linkedAccountsData?.filteredLinkAccountData?.length > 0 ? linkedAccountsData?.filteredLinkAccountData : null}
                    />
                  </Form.Item>
                  <div className=' bg-white' style={{ width: '100%' }}>
                    <div className='bg-[#FFFBE6] gap-3 p-2 rounded-lg flex border border-[#FFE58F]'>
                      <div className='mt-[2px]'>
                        <CautionIcon />
                      </div>
                      <div>Using the merchant ID you can create a payment link on behalf of that merchant account.</div>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
          {instanceData?.length > 0 && (
            <Form.Item label='Gateway Instance' className='formFields customFont'>
              <Select
                handleChange={onInstanceSelect}
                placeholder={'Select gateway instance'}
                loading={isInstanceFetching}
                showSearch
                allowClear
                value={instanceId}
                getPopupContainer={(triggerNode) => triggerNode.parentElement}
                filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
                optionsValue={instanceData?.length > 0 ? instanceData : null}
              />
            </Form.Item>
          )}
          {!store?.apiVersion && !location?.state?.order_id && (
            <Form.Item name='session_timer' valuePropName='checked' className='formFields customFont'>
              <Checkbox name='session_timer'>Enable Session Timer</Checkbox>
            </Form.Item>
          )}
        </div>
        <div className='mb-[-20px] form_button update-button'>
          <Form.Item>
            <div style={{ display: 'flex', justifyContent: 'right' }}>
              <ANTButton className='rounded-lg' block onClick={() => handleOpen()}>
                Cancel
              </ANTButton>
              <Button type='primary' htmlType='submit' block className='primaryBtn ml-4 rounded-lg' loading={loading}>
                Submit
              </Button>
            </div>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};
export default GeneratePaymentLink;
